export default __webpack_public_path__ + "static/media/chat.0e6b4bb9.svg";